import { useFormContext, Controller } from "react-hook-form";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, CircularProgress } from "@mui/material";
import SelectAgrotoxico from "../../../../../../../components/SelectsSimpleApiQuery/SelectAgrotoxico";
import SelectCultura from "../../../../../../../components/SelectsSimpleApiQuery/SelectCultura";

interface PropsEditarPrescricao {
    open: boolean;
    onClose: () => void;
    isEditing: boolean;
    handleFormSubmit: (data: any) => void;
}

export default function DialogEditarDadosPrincipais({
    open,
    onClose,
    isEditing,
    handleFormSubmit
}: PropsEditarPrescricao) {
    const { handleSubmit, control } = useFormContext();

    return (
        <Dialog open={open} fullWidth maxWidth="md" onClose={onClose}>
            <DialogTitle>Editar Dados principais</DialogTitle>
            <DialogContent>
                <Grid container spacing={2} mt={1}>
                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            name="formulacao"
                            control={control}
                            rules={{ required: "Formulação é obrigatório" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Formulação"
                                    type="string"
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            name="concentracao"
                            control={control}
                            rules={{ required: "Concentração é obrigatório" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Concentração"
                                    type="string"
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            name="cultura"
                            control={control}
                            rules={{ required: "Cultura é obrigatório" }}
                            render={({ field, fieldState: { invalid } }) => (

                                <SelectCultura
                                    required
                                    error={invalid}
                                    unique_select={true}
                                    value={field.value ?? []}
                                    onChange={field.onChange}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            name="agrotoxico"
                            control={control}
                            rules={{ required: "Agrotóxico é obrigatório" }}
                            render={({ field, fieldState: { invalid } }) => (

                                <SelectAgrotoxico
                                    required
                                    error={invalid}
                                    unique_select={true}
                                    value={field.value ?? []}
                                    onChange={field.onChange}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose} disabled={isEditing}>
                    Cancelar
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    disabled={isEditing}
                    onClick={handleSubmit(handleFormSubmit)}
                    startIcon={isEditing ? <CircularProgress size={20} color="inherit" /> : null}
                >
                    {isEditing ? "Editar..." : "Editar"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}